import "./styles/main.css";
import "./scripts/main";

// Expose Splide globally for standalone component files
import { Splide } from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';
window.Splide = Splide;
window.SplideIntersection = Intersection;
